import ScreenWrapper from "@/components/ScreenWrapper"
import { StudentOnboardingStepper } from "@/pages/student-onboarding/StudentOnboardingStepper"
import { StudentOnboardingScoped } from "@/pages/student-onboarding/StudentOnboardingStepperDefinition"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/student-onboarding/")({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <ScreenWrapper>
      <StudentOnboardingScoped>
        <StudentOnboardingStepper />
      </StudentOnboardingScoped>
    </ScreenWrapper>
  )
}
